var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.616 8.228C7.616 8.69467 7.49933 9.13333 7.266 9.544C7.042 9.95467 6.706 10.3 6.258 10.58C5.81933 10.86 5.29667 11.028 4.69 11.084V12.218H3.78V11.084C2.90267 11 2.19333 10.7247 1.652 10.258C1.11067 9.79133 0.84 9.17533 0.84 8.41H2.548C2.576 8.774 2.69267 9.07733 2.898 9.32C3.10333 9.55333 3.39733 9.70267 3.78 9.768V6.688C3.15467 6.52933 2.646 6.37067 2.254 6.212C1.862 6.044 1.526 5.78267 1.246 5.428C0.975333 5.07333 0.84 4.588 0.84 3.972C0.84 3.19733 1.11067 2.558 1.652 2.054C2.19333 1.54067 2.90267 1.242 3.78 1.158V0.0239995H4.69V1.158C5.51133 1.23267 6.16933 1.494 6.664 1.942C7.168 2.38067 7.45267 2.98733 7.518 3.762H5.81C5.782 3.47267 5.67 3.216 5.474 2.992C5.278 2.75867 5.01667 2.6 4.69 2.516V5.54C5.31533 5.68933 5.824 5.848 6.216 6.016C6.608 6.17467 6.93933 6.43133 7.21 6.786C7.48067 7.13133 7.616 7.612 7.616 8.228ZM2.464 3.888C2.464 4.27067 2.576 4.56933 2.8 4.784C3.03333 4.99867 3.36 5.17133 3.78 5.302V2.474C3.37867 2.52067 3.05667 2.66533 2.814 2.908C2.58067 3.15067 2.464 3.47733 2.464 3.888ZM4.69 9.768C5.10067 9.70267 5.42267 9.53933 5.656 9.278C5.88933 9.00733 6.006 8.68533 6.006 8.312C6.006 7.93867 5.88933 7.64933 5.656 7.444C5.432 7.22933 5.11 7.05667 4.69 6.926V9.768Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.be684755.svg";
export { ForwardRef as ReactComponent };